var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSightseeing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2010_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3936 12.1464H2.46879L0.0966797 8.3301L2.46879 4.51331H15.3936V12.1464ZM2.9898 11.2089H14.4561V5.45081H2.9898L1.20059 8.3301L2.9898 11.2089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5601 20.7431H16.6226V0.9375H13.3774V3.47414H12.4399V0H17.5601V20.7431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3774 13.0913H12.4399V20.7432H13.3774V13.0913Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1288 24.8053H10.8708V21.9019H19.1288V24.8053ZM11.8083 23.8678H18.1913V22.8394H11.8083V23.8678Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5316 9.0352H17.3738V8.0977H27.0101L28.7996 5.21794L27.0101 2.33911H17.3738V1.40161H27.5311L29.9032 5.21794L27.5316 9.0352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9035 4.75012H17.3738V5.68762H24.9035V4.75012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6329 7.86145H5.38208V8.79895H12.6329V7.86145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6644 23.8678H20.2983V24.8053H28.6644V23.8678Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70146 23.8678H1.33521V24.8053H9.70146V23.8678Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 26.3947H6.63403V27.3322H15V26.3947Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 29.0625H10.6826V30H15V29.0625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9716 26.3947H16.6731V27.3322H21.9716V26.3947Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2010_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSightseeing);
export default __webpack_public_path__ + "static/media/sightseeing.67f3e60ecbeaa2c42d58622b3c9f82ca.svg";
export { ForwardRef as ReactComponent };